import TicketView from '../../components/TicketView'
import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { Link, useParams } from 'react-router-dom'
import Copyright from '../../components/common/Copyright'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { useProject } from '../../context/ProjectContext'
import { useEffect, useState } from 'react'


export default function TicketViewPage({ setBlockScreen }: any) {
  const { project_code, ticket_number, tab } = useParams()
  const { selectedProject, setSelectedProject } = useProject()

  useEffect(() => {
    if (project_code) {
      setSelectedProject(project_code)
    }
  }, [project_code])

  return (<>
    <TopSideBar currentSection='tickets' disableProjectSelector />

    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs
          pathlist={[
            <Link className="breadcrumbs-nav__link" to="/tickets/listing">Home</Link>,
            <Link className="breadcrumbs-nav__link" to="/tickets/listing">Tickets</Link>,
            'Detalle'
          ]} />
      </Box>

      <TitlebarAction title={`Ticket: #${ticket_number}`} />

      {(selectedProject === project_code) && ticket_number && (
        <TicketView
          ticket_number={ticket_number}
          setBlockScreen={setBlockScreen}
          tab={tab}
          action='view'
        />
      )}

      <Copyright />

    </PageContainer>
  </>)
}
